<template>
    <div>
        <div>
            <h4>Prime Memeber Settings</h4>
            <hr class="bg-dark">
            <div class="form-group">
                <p>Non Prime Message</p>
                <textarea 
                    type="text"
                    ref="nonPMMessage"
                    class="form-control" 
                    placeholder="Message to show to non prime members when they try to access prime features" 
                    v-model="settings.nonPMMessage"
                    maxlength="1024">
                </textarea>
            </div>
            <div class="form-group">
                <p>Renew Message</p>
                <textarea 
                type="text"
                ref="renewMessage"
                class="form-control" 
                placeholder="Message to show to prime members when thier plan expires."
                v-model="settings.renewMessage"
                maxlength="1024"></textarea>
            </div>
        </div>
        <div>
            <h4>Referral Settings</h4>
            <hr class="bg-dark">
            <div class="form-group">
                <div class="input-group mb-3">
                    <p>Referral Notification <Info text="Send message to channel/group on new referral."/></p>
                    <div class="input-group-append mx-3">
                        <ToggleSwitch :value="chat_referral_notify==1" @input="toggleBotStatus"></ToggleSwitch>
                    </div>
              </div>
                
            </div>
           
        </div>
        <button
            class="btn btn-outline-primary btn-block my-5"
            @click="updateSettings">
            Update Settings
        </button>
    </div>
</template>

<script>
import Info from "@/components/Info.vue";
import ToggleSwitch from "@/components/ToggleSwitch.vue";


export default {
    name: 'Settings',
    components:{
        Info,
        ToggleSwitch
    },
    props:{
        settings: Object
    },
    data: function(){
        return{
            chat_referral_notify: this.settings.chat_referral_notify
        }
    },
    methods:{
        updateSettings(){
            if (this.settings.nonPMMessage == null || this.settings.nonPMMessage.trim() == "") {
                this.$refs.nonPMMessage.focus();
                return;
            }
            if (this.settings.renewMessage == null || this.settings.renewMessage.trim() == "") {
                this.$refs.renewMessage.focus();
                return;
            }
            this.settings.chat_referral_notify = this.chat_referral_notify
            this.$emit('updateSettings', this.settings)
        },
        toggleBotStatus(){
            if (this.chat_referral_notify == 1){this.chat_referral_notify = 0} else {this.chat_referral_notify = 1}
        }

    }
}
</script>